import { ButtonProps, CSSObject } from "@mui/material";
import colors from "theme/theme-light/colors";

const { text, background } = colors;
type ButtonVariantStyle = {
  props: Partial<ButtonProps>;
  style: CSSObject;
};
const variantBlur: ButtonVariantStyle[] = [
  {
    props: { variant: "blur", color: "primary" },
    style: {
      backgroundColor: background.bgBrandPrimary,
      color: text.textLink,
      "&:hover": {
        backgroundColor: background.bgBrandPrimary,
      },
    },
  },
  {
    props: { variant: "blur", color: "success" },
    style: {
      backgroundColor: background.bgPositivePrimary,
      color: text.textPositive,
      "&:hover": {
        backgroundColor: background.bgPositivePrimary,
      },
    },
  },
  {
    props: { variant: "blur", color: "error" },
    style: {
      backgroundColor: background.bgNegativePrimary,
      color: text.textNegative,
      "&:hover": {
        backgroundColor: background.bgNegativePrimary,
      },
    },
  },
  {
    props: { variant: "blur", color: "warning" },
    style: {
      backgroundColor: background.bgWarningPrimary,
      color: text.textWarning,
      "&:hover": {
        backgroundColor: background.bgWarningPrimary,
      },
    },
  },
];

export default variantBlur;
